// extracted by mini-css-extract-plugin
export default {"cardsScroller":"responsiveStyles_cardsScroller__6PDFM"};